export * from "./engine.prefilteredCubeTexture.types";
/**
 * Re-exports pure implementation and applies runtime side effects.
 * Import engine.prefilteredCubeTexture.pure for tree-shakeable, side-effect-free usage.
 */
export * from "./engine.prefilteredCubeTexture.pure";
import { RegisterEnginePrefilteredCubeTexture } from "./engine.prefilteredCubeTexture.pure";
RegisterEnginePrefilteredCubeTexture();
//# sourceMappingURL=engine.prefilteredCubeTexture.js.map